import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import productionitemList from './lists/productionitemList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import productionitemForm from "./forms/productionitemForm";
import ModalEditor from "./ModalEditor";
import Button from "../form/Button";

class productionitemEditor extends React.Component {

    state = {
        editorHeader: "Új gyártás"
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: "Gyártás"});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.setState({editorHeader: "Új gyártás"});
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
        this.editor && this.editor.hide();
    }

    render() {
        const ProductionitemForm = productionitemForm;
        const ProductionitemList = productionitemList;
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    key={1}
                    theme="default"
                    header={"Gyártások"}
                    footer={[
                        <Button key="0" disabled={this.props.isLoading} color="default" onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <ProductionitemList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    key={2}
                    theme="default"
                    header={this.state.editorHeader}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <ProductionitemForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "productionitem", WrappedComponent: productionitemEditor});
